import NiceModal, { useModal } from '@ebay/nice-modal-react'
import type { ButtonHTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'

import closeModal from '../../utils/closeModal'
import Modal from '../common/modal'
import Spinner from '../common/spinner'

interface CancelTransactionModalProps {
  isLoading: boolean
  onClick: () => Promise<void>
}

const Button = ({
  children,
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button
    className={
      'w-[120px] xl:w-[170px] text-center text-lg xl:text-2xl bg-secondary-txt-10 text-highlight font-medium font-Avenir-Medium transition-all duration-200 ease-in-out cursor-pointer px-0 py-[7px] rounded-[22px] xl:rounded-[26px]'
    }
    {...rest}>
    {children}
  </button>
)

const CancelTransactionModal = ({
  isLoading,
  onClick,
}: CancelTransactionModalProps) => {
  const modal = useModal()
  const { t } = useTranslation(['common', 'walletManagement'])

  return (
    <Modal
      id="cancel-transaction-modal"
      containerStyle="xl:max-w-[450px]"
      zIndex={220}>
      <p className="text-txt text-2xl xl:text-3xl font-bold text-center font-Avenir-Heavy mb-4">
        {t('cancel-transaction', { ns: 'walletManagement' })}
      </p>
      <p className="text-[15px] xl:text-xl text-txt text-center font-medium font-Avenir-Medium mb-6 px-[50px] py-0">
        {t('cancel-sure', { ns: 'walletManagement' })}
      </p>
      <div className="flx-ctr" style={{ gap: '16px' }}>
        {isLoading ? (
          <Spinner containerStyle={{ width: '120px' }} spinnerSize={30} />
        ) : (
          <Button onClick={onClick}>{t('yes', { ns: 'common' })}</Button>
        )}
        <Button onClick={() => closeModal(modal)}>
          {t('no', { ns: 'common' })}
        </Button>
      </div>
    </Modal>
  )
}

export default NiceModal.create(CancelTransactionModal)
